export const SAVE = 'step17.SAVE';
export const VALUE_CHANGED = 'step17.VALUE_CHANGED';
export const LOAD = 'step17.VALUE_LOAD';
export const RESET = 'step17.RESET';
export const RESET_GIVE_PERMISSION_STATE = 'step17.RESET_GIVE_PERMISSION_STATE';
export const SET_DEFAULT_VALUE = 'step17.SET_DEFAULT_VALUE';



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step17/constants.js